import React from "react";
import { Star } from "lucide-react";
import ResourceManager from "../../components/admin/ResourceManager";

const TESTIMONIAL_FIELDS = [
    { key: "name",     label: "Client Name",   type: "text",     required: true, placeholder: "Rahul Mehta" },
    { key: "business", label: "Business",      type: "text",     placeholder: "Mehta Sweets, Pune" },
    { key: "text",     label: "Review Text",   type: "textarea", required: true, rows: 4, placeholder: "What the client said…" },
    { key: "rating",   label: "Rating (1–5)",  type: "number",   defaultValue: 5 },
    { key: "position", label: "Position",      type: "number" },
    { key: "visible",  label: "Visibility",    type: "switch", defaultValue: true },
];

export const AdminTestimonialsPage = () => (
    <ResourceManager
        resourceKey="testimonials"
        title="Testimonials Manager"
        singular="Testimonial"
        description="Add, edit and reorder client reviews shown on the homepage."
        endpoint="/admin/testimonials"
        fields={TESTIMONIAL_FIELDS}
        renderItem={(item) => (
            <div>
                <div className="flex items-center gap-1 mb-2">
                    {Array.from({ length: Math.max(0, Math.min(5, item.rating || 0)) }).map((_, i) => (
                        <Star key={i} size={12} className="text-gold fill-gold" strokeWidth={1.5} />
                    ))}
                </div>
                <p className="font-inter text-sm text-zinc-300 line-clamp-2">{item.text}</p>
                <div className="mt-2 font-poppins text-white text-sm">
                    {item.name}
                    <span className="font-inter text-zinc-500 ml-2 text-xs">{item.business}</span>
                </div>
            </div>
        )}
    />
);

export default AdminTestimonialsPage;
